export function isVaultTelemetryPath(pathname: string): boolean {
  return (
    /(?:^|\/)vaults(?:\/|$)/.test(pathname) ||
    /^\/oauth\/(link|agentcard)\/success\/?$/.test(pathname)
  );
}

export function isVaultTelemetryURL(value: string): boolean {
  try {
    return isVaultTelemetryPath(new URL(value, 'https://dashboard.invalid').pathname);
  } catch {
    return false;
  }
}

export function vaultTelemetryBlocked(): boolean {
  return (
    typeof window !== 'undefined' &&
    (isVaultTelemetryPath(window.location.pathname) ||
      !!document.querySelector('[data-vault-sensitive]'))
  );
}

export function containsVaultTelemetryURL(value: unknown): boolean {
  if (typeof value === 'string') return isVaultTelemetryURL(value);
  if (Array.isArray(value)) return value.some(containsVaultTelemetryURL);
  if (value && typeof value === 'object')
    return Object.values(value).some(containsVaultTelemetryURL);
  return false;
}
